import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const VerticalTemplateOneOneSix = ({
  logoImage = "/yourLogo.svg",
  logoImagePreview = null,

  titleText = "MAKE YOUR NEXT MOVE",
  titleFont = "Helvetica",
  titleFontSize = "48",
  titleColor = "#E91E63",
  titleTextAlign = "center",
  titleIsBold = true,
  titleIsItalic = false,
  titleIsUnderline = false,

  subtitleText = "A quick action to keep momentum.",
  subtitleFont = "Helvetica",
  subtitleFontSize = "18",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "center",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  backgroundType = "color",
  backgroundColor = "#1A2B8C",
  backgroundImage = null,

  buttonLabel = "Get started",
  buttonFont = "Helvetica",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "16",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#E91E63",

  backgroundImagePreview,

  preview = false,
  inmeeting = false,
  onClose,
  position = "left",
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 767;

  return (
    <div
      className={`relative ${
        !inmeeting
          ? "h-full"
          : isMobile
          ? "h-full"
          : "!h-[calc(100vh-var(--topbar-height,64px)-60px)] w-72"
      } ${
        isMobile && inmeeting
          ? position === "left" || position === "right"
            ? "" // Let it size naturally
            : "w-full" // Fill container for center/top/bottom
          : "w-72"
      } flex flex-col mx-auto justify-between items-center p-4 md:p-8 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && meetingRole === "moderator" && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container */}
      <div className="relative h-full z-10 flex flex-col justify-center items-center w-full max-w-4xl mx-auto gap-6 md:gap-8">
        {/* Logo */}
        {(logoImage || logoImagePreview) && (
          <div className="mb-4">
            <img
              src={
                logoImage instanceof File
                  ? logoImagePreview
                  : logoImage || "/yourLogo.svg"
              }
              alt="logo"
              className="w-16 h-16 md:w-20 md:h-20 object-contain"
            />
          </div>
        )}

        {/* Main Heading */}
        <h1
          className={`text-center uppercase ${
            explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
          }`}
          style={{
            color: titleColor,
            fontSize: `${titleFontSize}px`,
            fontFamily: titleFont,
            textAlign: titleTextAlign,
            lineHeight: "1.1",
            whiteSpace: "pre-line",
          }}
        >
          {titleText}
        </h1>

        {/* Subtitle */}
        <div
          className={`text-center ${
            explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
          }`}
          style={{
            color: subtitleColor,
            fontSize: `${subtitleFontSize}px`,
            fontFamily: subtitleFont,
            textAlign: subtitleTextAlign,
            whiteSpace: "pre-line",
            marginTop: "10px",
          }}
        >
          {subtitleText}
        </div>

        {/* Button */}
        <button
          className={`px-8 py-3 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl mt-6 ${
            buttonLink ? "cursor-pointer" : "cursor-default"
          }`}
          style={{
            backgroundColor: buttonBackgroundColor,
            color: buttonFontColor,
            fontSize: `${buttonFontSize}px`,
            fontFamily: buttonFont,
            fontWeight: explicitBoleanCheck(buttonIsBold) ? "bold" : "normal",
            fontStyle: explicitBoleanCheck(buttonIsItalic)
              ? "italic"
              : "normal",
            textDecoration: explicitBoleanCheck(buttonIsUnderline)
              ? "underline"
              : "none",
          }}
          onClick={() => {
            if (buttonLink) {
              window.open(buttonLink, "_blank");
            }
          }}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default VerticalTemplateOneOneSix;
